module.exports = __webpack_public_path__ + "img/40.d3d91dc7.webp";